export enum UploadType {
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  ATTACHMENT = 'attachment',
  MODEL3D = 'model_3d'
}

export interface UploadOptions {
  checkPublish: boolean;
  uploadAsAttachments: boolean;
}

export interface UploadRetryOptions {
  maxAttempts?: number
  baseDelay?: number;
  maxDelay?: number;
}

export interface UploadItem {
  id: string;
  uploadType: UploadType,
  artifactId: string | null;
  fileName: string;
  state: 'pending' | 'uploading' | 'success' | 'failed';
  status: number;
  statusText: string;
  uploadStatus: string | null;
  uploadStatusText: string | null;
  uploadStatusCounter: number | null;
}

export interface UploadResult {
  uploadStatus: string;
  statusText: string;
  startTime: Date;
  endTime: Date | null;
  items: UploadItem[];
}
